import * as React from "react";
const AnalysisIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#analysis_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12.384 37.796-7.179 7.18a4.115 4.115 0 0 0 5.82 5.819l7.179-7.18a24.009 24.009 0 0 1-5.82-5.819Zm13.619-13.798h-4a1.003 1.003 0 0 0-1 1v4.94a12.572 12.572 0 0 0 6 5.518V24.998a1.003 1.003 0 0 0-1-1Zm15.998-6h-4a1.003 1.003 0 0 0-1 1v16.458a12.572 12.572 0 0 0 6-5.519V18.998a1.003 1.003 0 0 0-1-1Zm-7.999 3h-4a1.003 1.003 0 0 0-1 1v14.138c1.972.48 4.029.48 6 0V21.998a1.003 1.003 0 0 0-1-1Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.002 4a19.998 19.998 0 1 0 0 39.995 19.998 19.998 0 0 0 0-39.995Zm10.999 30.177a14.998 14.998 0 1 1-21.998-20.394 14.998 14.998 0 0 1 21.998 20.394Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "analysis_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v56H0z"
}))));
export default AnalysisIcon;